import { IThemeProps } from "./IThemeProps";

const light: IThemeProps = {
  colors: {
    primary: '#fe157e',
    secondary: '#ffffff',
    tertiary: '#00ee98',
    success: '',
    danger: '#d94545',
    pink: '#fe157e',
    warning: '',
    info: '#582CFF',
    light: '',
    white: '#3e3f5e',
    dark: '#ffffff',
    muted: '#9ea4c1',
    gray: '#dadbe7',
    whiteGray: '#adafca',
    purple: '#72169b',
  },
  gradients: {
    primary: 'linear-gradient(220deg, #72169b, #480c62)',
    secondary: 'linear-gradient(-180deg, #ffffff 0%, #ffffff 50%)',
    tertiary: 'linear-gradient(-180deg, #ffffff 0%, #ffffff 50%)',
    rankingGradient: 'radial-gradient(circle,#fafafc  0%, #fafafc 100%)',
  },
  radius: {
    primary: '24px',
    secondary: '12px',
  },
  header: {
    header: '#72169b',
    subHeader: '#72169b',
    gradient: 'linear-gradient(220deg, #72169b, #480c62)',
    border: '#ffffff20',
    inputSearch: '#ffffff20',
    inputSearchBorder: '#ffffff20',
  },
  menu: {
    buttonBackground: '#ffffff',
    buttonColor: '#fe157e',
    buttonShadow: 'rgb(94 92 154 / 12%) 3px 5px 30px 0px',
    buttonShadowHover: 'none',
  },
  dropDownMenu: {
    background: 'linear-gradient(220deg, #72169b, #480c62)',
    border: '2px solid #8433a8',
  },
  cards: {
    primary: '#ffffff',
    secondary: '#182e12',
    tertiary: '#f8fcff',
    backgroundSpinner: '#ffffff',
    backdropFilter: 'blur(7px) saturate(400%)',
    border: '#1fb3971f',
    modal: '#f0f8ff70',
  },
  modal: {
    background: '#ffffffe6',
    border: '#3e3f5e40',
    closeButton: '#3e3f5e',
  },
  background: {
    primary: '#f0f8ff',
    secondary: '#ffffff',
    tertiary: '#f7fafc', 
  },
  shadows: {
    //primary: 'rgb(94 92 154 / 6%) 0px 0px 40px 0px',
    primary: 'none',
  },
  input: {
    background: '#ffffff',
    border: '#3e3f5e40',
    borderActive: '#3e3f5e',
    labelColor: '#3e3f5e',
  },
  specific: {
    menuTitles: '#00ee98',
    menuBorder: '11px 2px 39px -8px rgb(114 22 155 / 7%)',
    menuButton: '#00ee98',
    menuDropDownAvatarButtonOnHover: '#ffffff20',
    menuButtonTriggerBorder: '#1fb3971f',
    cardGradient3D: 'linear-gradient(140deg, #ffffff80 0%, transparent 54%)',
    cardGradientShadow: '0px 0px 70px #11111140',
    inputSearchHeaderBg: '#72169b',
    loaderBg: 'radial-gradient(#17b585 0, transparent 100%)',
    clockDown: '#fafafc',
    asideModule: '#ffffff',
    footerModule: '#ffffff',
    cardDashedBorder: '#ffffff4a',
    cardCommunity: '#ffffff',
    svgFilterRecolor: 'invert(20%) sepia(10%) saturate(2301%) hue-rotate(200deg) brightness(95%) contrast(81%)',
    avatarBorderColor: '#ffffff',
    verifyBorderAnimationColor: '#9080fa20',
    wysiwygButtons: '#3e3f5e',
  },
}

export default light;
